module.exports = __webpack_public_path__ + "img/edit-icon.2a47d45.png";